<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
  >
    <g id="icon_list_application" transform="translate(1580 2999)">
      <path
        id="패스_3897"
        data-name="패스 3897"
        fill-opacity="0"
        d="M0,0H24V24H0Z"
        transform="translate(-1580 -2999)"
      />
      <g id="그룹_8348" data-name="그룹 8348">
        <rect
          id="사각형_5792"
          data-name="사각형 5792"
          fill="#d5d8dc"
          width="18"
          height="18"
          rx="2"
          transform="translate(-1577 -2994)"
        />
        <path
          id="빼기_1"
          data-name="빼기 1"
          fill="#21bf54"
          d="M14,6H-4V4A2,2,0,0,1-2,2H2.171A3,3,0,0,1,7.829,2H12a2,2,0,0,1,2,2V6ZM5,2A1,1,0,1,0,6,3,1,1,0,0,0,5,2Z"
          transform="translate(-1573 -2998)"
        />
        <rect
          id="사각형_5793"
          data-name="사각형 5793"
          fill="#363c43"
          width="10"
          height="2"
          transform="translate(-1573 -2989)"
        />
        <rect
          id="사각형_5795"
          data-name="사각형 5795"
          fill="#363c43"
          width="7"
          height="2"
          transform="translate(-1573 -2985)"
        />
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>
